import { render, staticRenderFns } from "./MainMessage.vue?vue&type=template&id=5dc9e606&scoped=true"
import script from "./MainMessage.vue?vue&type=script&lang=js"
export * from "./MainMessage.vue?vue&type=script&lang=js"
import style0 from "./MainMessage.vue?vue&type=style&index=0&id=5dc9e606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9e606",
  null
  
)

export default component.exports